import React, { useRef, useEffect, useState } from 'react';
import { isNil } from 'lodash';
import Tooltip from 'components/Tooltip';

export type OverflowTooltipProps = {
  text: string;
  maxSize?: number;
  className?: string;
  tipId?: string;
  prefix?: React.ReactNode;
  style?: React.CSSProperties;
  tooltipProps?: Record<string, any>;
};

export const OverflowTooltip = ({
  tipId,
  style,
  className = '',
  text = '',
  prefix,
  tooltipProps = {},
}: OverflowTooltipProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  // when text is smaller than the container width, it can show the overflow tooltip
  useEffect(() => {
    const { current } = textRef;
    if (current) {
      setIsOverflowed(current.scrollWidth > current.clientWidth);
    }
  }, [text]);

  return (
    !isNil(text) && (
      <>
        {isOverflowed && (
          <Tooltip
            id={tipId || text}
            place='bottom'
            className='z-[10000]'
            delayShow={200}
            {...tooltipProps}
          >
            {text}
          </Tooltip>
        )}
        <div
          ref={textRef}
          className={`overflow-hidden whitespace-nowrap text-ellipsis ${className}`}
          style={{ ...style }}
          data-tip={isOverflowed ? text : ''}
          data-for={tipId || text}
        >
          {prefix}
          {text}
        </div>
      </>
    )
  );
};
